module.exports = __webpack_public_path__ + "img/Risk2.894dcf64.svg";